import loadable from "@loadable/component";
import { lazyRetry } from "../hooks/helpers";
import { lazy } from "react";

export const FileToBig = loadable(() =>
  lazyRetry(() => import("./modals/fileToBig"))
);
export const ModalFaildReques = loadable(() =>
  lazyRetry(() => import("./modals/modalFaildReques"))
);
export const LinkPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/linkPage"))
);
export const WifiPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/wifiPage"))
);
export const PdfPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/pdfPage"))
);
export const CreateVCard = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/vCardPage"))
);
export const EmailPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/emailPage"))
);
export const PlayMarketAppstore = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/playMarketAppstore"))
);
export const WhatsAppPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/whatsAppPage"))
);
export const AudioPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/audioPage"))
);
export const PptxPpt = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/pptxPpt"))
);
export const TextPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/textPage"))
);
export const GallerryPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/gallerryPage"))
);
export const LinkListPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/linkListPage"))
);
export const CryptoPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/cryptoPage"))
);
export const InstagramPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/instagramPage"))
);
export const FacebookPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/facebookPage"))
);
export const TelegramPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/telegramPage"))
);
export const TiktokPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/tiktokPage"))
);
export const SnapchatPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/snapchatPage"))
);
export const TwitterPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/twitterPage"))
);
export const YoutubePage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/youtubePage"))
);
export const MultiUrlPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/multiUrlPage"))
);
export const ModalSwitchMultiUrlType = loadable(() =>
  lazyRetry(() => import("./modals/modalSwitchMultiUrlType"))
);
export const MapPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/mapPage"))
);
export const PcrPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/pcrPage"))
);
export const PhonePage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/phonePage"))
);
export const SmsPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/smsPage"))
);
export const VideoPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/videoPage"))
);
export const PaypalPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/paypalPage"))
);
export const SheetsPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/sheetsPage"))
);
export const LogoPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/logoPage"))
);
export const PaymentPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/paymentPage"))
);
export const DocPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/docPage"))
);
export const FormPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/formPage"))
);
export const ReviewPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/reviewPage"))
);
export const PngPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/pngPage"))
);
export const SpotifyPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/spotifyPage"))
);
export const OfficePage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/officePage"))
);
export const EtsyPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/etsyPage"))
);
export const ShapedPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/shapedPage"))
);
export const SocialMediaPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/socialMediaPage"))
);
export const RedditPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/redditPage"))
);
export const LinkedinPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/linkedinPage"))
);
export const CalendarPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/calendarPage"))
);
export const FilePage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/filePage"))
);
export const ModalStorage = loadable(() =>
  lazyRetry(() => import("./modals/modalStorage"))
);
export const NotFound = loadable(() => lazyRetry(() => import("./notFound")));

export const OverlayQrModal = loadable(() =>
  lazyRetry(() => import("./modals/overlayQrModal"))
);
export const ModalQrCode = loadable(() =>
  lazyRetry(() => import("./modals/modalQrCode"))
);
export const ModalSuccessfullyDownload = loadable(() =>
  lazyRetry(() => import("./modals/modalSuccessfullyDownload"))
);
export const ModalChooseQrType = loadable(() =>
  lazyRetry(() => import("./modals/modalChooseQrType"))
);
export const ModalFrames = loadable(() =>
  lazyRetry(() => import("./modals/modalFrames"))
);
export const ModalLogo = loadable(() =>
  lazyRetry(() => import("./modals/modalLogo"))
);
export const MobilePreview = loadable(() =>
  lazyRetry(() => import("../page/ThirdScreen/mobilePreview"))
);
export const ExcelPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/excelPage"))
);
export const ModalSlider = loadable(() =>
  lazyRetry(() => import("./modals/modalSlider"))
);
export const ThirdScreen = lazy(() =>
  lazyRetry(() => import("../page/ThirdScreen"))
);
export const FirstScreen = lazy(() =>
  lazyRetry(() => import("../page/FirstScreen"))
);
export const ModalTemplateApply = loadable(() =>
  lazyRetry(() => import("./modals/modalTemplateApply"))
);
export const BookingPage = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/bookingPage"))
);
export const ModalArtQrSwitch = loadable(() =>
  lazyRetry(() => import("./modals/modalArtQrSwitch"))
);
export const ModalClassicQrSwitch = loadable(() =>
  lazyRetry(() => import("./modals/modalClassicQrSwitch"))
);
export const ModalFreeTrial = loadable(() =>
  lazyRetry(() => import("./modals/modalFreeTrial"))
);
export const TrialFlow = loadable(() =>
  lazyRetry(() => import("../page/ThirdScreen/qrSettings/trialFlow"))
);
export const GeneratorPageTemplates = lazy(() =>
  lazyRetry(() => import("../page/SecondScreen/generatorPageTemplates"))
);
export const PosModal = lazy(() =>
  lazyRetry(() => import("./modals/modalPos"))
);
export const LandingPagesBlockDesktop = lazy(() =>
  lazyRetry(() =>
    import("./../page/FirstScreen/LandingPagesBlock/LandingPagesBlockDesktop")
  )
);
export const LandingPagesBlockMobile = lazy(() =>
  lazyRetry(() =>
    import("./../page/FirstScreen/LandingPagesBlock/LandingPagesBlockMobile")
  )
);

export const ModalBackThirdStepLazy = loadable(() =>
  lazyRetry(() => import("./modals/modalBackThirdStep"))
);